import React from 'react';

const FilterSidebar = ({ filters, onFilterChange }) => {
  const publicationNames = [
    'Appleseeds', 'Ask', 'Babybug', 'Calliope', 'Cicada', 'Click', 
    'Cobblestone', 'Cricket', 'Dig', 'Faces', 'Footsteps', 'Ladybug', 
    'Muse', 'Odyssey', 'Spider'
  ];

  const workTypes = ['TEXT', 'ART', 'PHOTO'];
  const rightsLevels = ['A', 'B', 'C', 'D', 'E'];

  const publicationDates = [
    'Unassigned',
    'Jan 2024', 'Feb 2024', 'Mar 2024', 'Apr 2024', 'May 2024', 'Jun 2024',
    'Jul 2024', 'Aug 2024', 'Sep 2024', 'Oct 2024', 'Nov 2024', 'Dec 2024',
    'Jan 2023', 'Feb 2023', 'Mar 2023', 'Apr 2023', 'May 2023', 'Jun 2023',
    'Jul 2023', 'Aug 2023', 'Sep 2023', 'Oct 2023', 'Nov 2023', 'Dec 2023'
  ];

  const handleFilterChange = (filterName, value) => {
    onFilterChange({ [filterName]: value });
  };

  const clearFilters = () => {
    onFilterChange({
      workType: '',
      publicationName: '',
      publicationDate: '',
      rightsLevel: ''
    });
  };

  return (
    <div className="bg-white shadow rounded-lg p-6">
      <div className="flex justify-between items-center mb-4">
        <h3 className="text-lg font-medium text-gray-900">Filters</h3>
        <button
          onClick={clearFilters}
          className="text-sm text-indigo-600 hover:text-indigo-900"
        >
          Clear all
        </button>
      </div>

      <div className="space-y-6">
        {/* Work Type Filter */}
        <div>
          <label className="text-sm font-medium text-gray-700 block mb-2">
            Work Type
          </label>
          <select
            value={filters.workType}
            onChange={(e) => handleFilterChange('workType', e.target.value)}
            className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
          >
            <option value="">All Types</option>
            {workTypes.map((type) => (
              <option key={type} value={type}>
                {type}
              </option>
            ))}
          </select>
        </div>

        {/* Publication Name Filter */}
        <div>
          <label className="text-sm font-medium text-gray-700 block mb-2">
            Publication
          </label>
          <select
            value={filters.publicationName}
            onChange={(e) => handleFilterChange('publicationName', e.target.value)}
            className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
          >
            <option value="">All Publications</option>
            {publicationNames.map((name) => (
              <option key={name} value={name}>
                {name}
              </option>
            ))}
          </select>
        </div>

        {/* Publication Date Filter */}
        <div>
          <label className="text-sm font-medium text-gray-700 block mb-2">
            Publication Date
          </label>
          <select
            value={filters.publicationDate}
            onChange={(e) => handleFilterChange('publicationDate', e.target.value)}
            className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
          >
            <option value="">All Dates</option>
            {publicationDates.map((date) => (
              <option key={date} value={date}>
                {date}
              </option>
            ))}
          </select>
        </div>

        {/* Rights Level Filter */}
        <div>
          <label className="text-sm font-medium text-gray-700 block mb-2">
            Rights Level
          </label>
          <div className="space-y-2">
            {rightsLevels.map((level) => (
              <label key={level} className="flex items-center">
                <input
                  type="radio"
                  name="rightsLevel"
                  value={level}
                  checked={filters.rightsLevel === level}
                  onChange={(e) => handleFilterChange('rightsLevel', e.target.value)}
                  className="h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300"
                />
                <span className="ml-2 text-sm text-gray-700">Level {level}</span>
              </label>
            ))}
            <label className="flex items-center">
              <input
                type="radio"
                name="rightsLevel"
                value=""
                checked={filters.rightsLevel === ''}
                onChange={(e) => handleFilterChange('rightsLevel', e.target.value)}
                className="h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300"
              />
              <span className="ml-2 text-sm text-gray-700">All Levels</span>
            </label>
          </div>
        </div>

        {/* Sort Options */}
        <div>
          <label className="text-sm font-medium text-gray-700 block mb-2">
            Sort By
          </label>
          <select
            value={`${filters.sortBy}_${filters.sortOrder}`}
            onChange={(e) => {
              const value = e.target.value;
              console.log('[DEBUG] Sort dropdown changed to:', value);
              const lastUnderscoreIndex = value.lastIndexOf('_');
              const sortBy = value.substring(0, lastUnderscoreIndex);
              const sortOrder = value.substring(lastUnderscoreIndex + 1);
              console.log('[DEBUG] Parsed sortBy:', sortBy, 'sortOrder:', sortOrder);
              onFilterChange({ sortBy, sortOrder });
            }}
            className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
          >
            <option value="created_at_desc">Newest First</option>
            <option value="created_at_asc">Oldest First</option>
            <option value="publicationName_asc">Publication A-Z</option>
            <option value="publicationName_desc">Publication Z-A</option>
            <option value="publicationDate_desc">Publication Date (Recent)</option>
            <option value="publicationDate_asc">Publication Date (Oldest)</option>
          </select>
        </div>
      </div>
    </div>
  );
};

export default FilterSidebar;